var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9891 4.85486C12.676 4.62333 11.4243 5.49779 11.1932 6.80802L9.9816 13.6796C9.86608 14.3347 9.24021 14.7719 8.58368 14.6562C7.92714 14.5404 7.48856 13.9155 7.60407 13.2604L8.81572 6.3888C9.27777 3.76834 11.7813 2.01943 14.4074 2.48249L20.6542 3.58397C23.2804 4.04703 25.0347 6.54671 24.5726 9.16717L23.361 16.0387C23.2455 16.6938 22.6196 17.1311 21.9631 17.0153C21.3065 16.8995 20.868 16.2746 20.9835 15.6195L22.1951 8.74795C22.4261 7.43772 21.549 6.18788 20.2359 5.95635L13.9891 4.85486Z",
    fill: "url(#paint0_linear_8220_17058)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 12.2907C26.965 12.5784 28.0545 14.1343 27.7668 15.766L25.3357 29.5533C25.048 31.185 23.492 32.2745 21.8603 31.9868L4.1338 28.8611C2.50212 28.5734 1.41261 27.0175 1.70032 25.3858L4.1314 11.5985C4.41911 9.96679 5.97509 8.87728 7.60677 9.16499L25.3333 12.2907ZM13.2435 15.7487C12.9172 15.6912 12.6054 15.9086 12.5479 16.2349L12.0617 18.9922C12.0042 19.3185 12.2226 19.6304 12.5489 19.6879L12.8499 19.741C13.1762 19.7986 13.3938 20.1093 13.3363 20.4356L12.7145 23.9623C12.6569 24.2886 12.8753 24.6005 13.2016 24.658L13.9893 24.7969C14.3156 24.8544 14.6265 24.6359 14.6841 24.3096L15.3059 20.7829C15.3635 20.4566 15.6752 20.2392 16.0015 20.2967L16.291 20.3478C16.6173 20.4052 16.9282 20.1867 16.9858 19.8604L17.4719 17.1031C17.5295 16.7769 17.3118 16.4661 16.9856 16.4085L13.2435 15.7487Z",
    fill: "url(#paint1_linear_8220_17058)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8220_17058",
    x1: 15.2734,
    y1: 15.8357,
    x2: 17.5308,
    y2: 3.03323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00368E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C95FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8220_17058",
    x1: 15.5278,
    y1: 16.0804,
    x2: 15.8105,
    y2: 32.6228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEBF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9e7bdcaaf7474763edd25f3d24c64659.svg";
export { ForwardRef as ReactComponent };